import { Stack } from '@mui/material';
import { primaryDark, secondaryOrange, secondaryYellow } from '../../../utils/color';

import ReusableHeroSection from '../../../components/public-screen-components/ReusableHeroSection';
import HowDoesItWork from '../../../components/public-screen-components/HowDoesItWork';
import SponaOptions from '../../../components/public-screen-components/SponaOptions';
import BecomeAPartOfSpona from '../../../components/public-screen-components/BecomeAPartOfSpona';
import { PUBLIC_APPBAR_HEIGHT } from '../../../layout/public-layout/navigation/Navigation';
import MetaTags from '../../../components/seo/MetaTags';
import { getPublicImageUrl } from '../../../utils/helpers';
import { EnumPublicPagesImage } from '../../../utils/enums';

const metaTags = {
  title: `Spona - Are you a Digital Agency looking for work? `,
  description: `Get your next big project with Spona. Register, publish a Case Study and Get your next big project now. Find out here how it all works.`,
};

const HowToFindWork = () => (
  <>
    <MetaTags {...metaTags} />
    <Stack overflow="hidden" width="100%">
      <ReusableHeroSection
        title="Get Your Next Big Project"
        content="Grow your business while we bring the opportunities to you."
        image={getPublicImageUrl(EnumPublicPagesImage.HowToFindWorkHero)}
        sx={{ height: { xs: `calc(100vh + ${PUBLIC_APPBAR_HEIGHT}px)`, lg: '87vh' } }}
        alt="Two colleagues reading notes from multi color post it notes."
      />

      <HowDoesItWork
        items={[
          {
            id: 'create-a-profile',
            title: 'Create a profile',
            content:
              'To sign up for Spona, you need your company name and business email. After that, you will need to register your company details to create a full profile. You will be guided step-by-step through the entire process.',
            image: getPublicImageUrl(EnumPublicPagesImage.CreateProfile),
            color: secondaryYellow[100],
            alt: 'Ilustration_create a profile',
          },
          {
            id: 'publish-a-case-study',
            title: 'Publish a case study',
            content:
              'Once your profile is verified, you will be able to browse all projects listed on the platform. To enable pitching, you need to post at least one case study and request a review from your previous client. This gives proof of credibility and valuable insight to your future buyers.',
            image: getPublicImageUrl(EnumPublicPagesImage.PublishCaseStudy),
            color: secondaryYellow[100],
            alt: 'Illustration_Publish a case study',
          },
          {
            id: 'submit-your-pitch',
            title: 'Submit your pitch',
            content:
              'Describe your company, your proposed strategy and attach relevant material. If your pitch is approved, you will proceed to the second round where you have the opportunity to chat with the buyer and schedule a meeting to discuss the project in more detail.',
            image: getPublicImageUrl(EnumPublicPagesImage.SubmitYourPitch),
            color: secondaryYellow[100],
            alt: 'Illustration_Submit your pitch',
          },
        ]}
      />

      <SponaOptions
        title="Spona Gives Your Business…"
        clickableOptionBorderLeftColor={secondaryOrange[501]}
        optionsProps={[
          {
            id: 'reach',
            title: 'Reach',
            content:
              'Build your online presence by publishing content which showcases your products and know-how. Show your potential clients your expertise and promote your services ahead of time, giving you an increased chance of being selected for your next project.',
            image: getPublicImageUrl(EnumPublicPagesImage.SponaGives),
            alt: 'Personal computer showing statistic report on the screen',
          },
          {
            id: 'credibility',
            title: 'Credibility',
            content:
              'Connect with buyers through our platform and gain invaluable feedback and credibility through client-reviewed and scored project case studies. Our team will verify the content ourselves, creating a handy portfolio of thoroughly vetted work.  ',
            image: getPublicImageUrl(EnumPublicPagesImage.SponaGives),
            alt: 'Personal computer showing statistic report on the screen',
          },
          {
            id: 'opportunities',
            title: 'Opportunities',
            content:
              'Browse projects and find out immediately what your potential clients are looking for. Show them that you’ve got exactly what they need by submitting a pitch with our user-friendly template.',
            image: getPublicImageUrl(EnumPublicPagesImage.SponaGives),
            alt: 'Personal computer showing statistic report on the screen',
          },
        ]}
      />

      <BecomeAPartOfSpona
        title="Ready to land your next big client?"
        subtitle="Join the Spona networK. "
        bgcolor="secondaryYellow.100"
        color={primaryDark[900]}
      />
    </Stack>
  </>
);

export default HowToFindWork;
